import { render, staticRenderFns } from "./WebinarsMain.vue?vue&type=template&id=907872d6&"
import script from "./WebinarsMain.vue?vue&type=script&lang=js&"
export * from "./WebinarsMain.vue?vue&type=script&lang=js&"
import style0 from "./WebinarsMain.vue?vue&type=style&index=0&id=907872d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports